import React from 'react';

// Контуры иконок (viewBox 24×24, stroke). Эмодзи как иконки не используем.
export const ICONS = {
  today: 'M3 11l9-8 9 8M5 10v10h5v-6h4v6h5V10',
  train: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 7a5 5 0 1 0 0 10a5 5 0 1 0 0-10M12 11a1 1 0 1 0 0 2a1 1 0 1 0 0-2',
  lessons: 'M2 5h7a3 3 0 0 1 3 3v12a2 2 0 0 0-2-2H2zM22 5h-7a3 3 0 0 0-3 3v12a2 2 0 0 1 2-2h8z',
  words: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  sentences: 'M4 5h16v11H8l-4 4z',
  rules: 'M6 3h12v18l-6-4-6 4z',
  sets: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5',
  leaderboard: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  friends: 'M9 11a4 4 0 1 0 0-8a4 4 0 1 0 0 8M2 21v-1a6 6 0 0 1 12 0v1M16 3.5a4 4 0 0 1 0 7.5M22 21v-1a6 6 0 0 0-4-5.6',
  achievements: 'M12 15a6 6 0 1 0 0-12a6 6 0 1 0 0 12M8.5 14L7 22l5-3 5 3-1.5-8',
  settings: 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M14 4v4M8 10v4M16 16v4',
  users: 'M16 21v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1M9 12a4 4 0 1 0 0-8a4 4 0 1 0 0 8M19 8v6M22 11h-6',
  logout: 'M15 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4M10 17l-5-5 5-5M5 12h11',
  play: 'M7 4l13 8-13 8z',
  menu: 'M4 6h16M4 12h16M4 18h16',
  close: 'M6 6l12 12M18 6L6 18',
  plus: 'M12 5v14M5 12h14',
  check: 'M5 12l5 5 9-10',
  minus: 'M6 12h12',
  chevronRight: 'M9 6l6 6-6 6',
  chevronLeft: 'M15 6l-6 6 6 6',
  chevronDown: 'M6 9l6 6 6-6',
  search: 'M11 4a7 7 0 1 0 0 14a7 7 0 1 0 0-14M20 20l-4-4',
  alert: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 8v5M12 16h.01',
  info: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 11v5M12 8h.01',
  trash: 'M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13',
  edit: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
  upload: 'M12 16V4M7 9l5-5 5 5M4 20h16',
  download: 'M12 4v12M7 11l5 5 5-5M4 20h16',
  sparkles: 'M12 3l1.8 4.2L18 9l-4.2 1.8L12 15l-1.8-4.2L6 9l4.2-1.8zM19 15l.8 1.7 1.7.8-1.7.8L19 20l-.8-1.7-1.7-.8 1.7-.8z',
  volume: 'M4 9v6h4l5 4V5L8 9zM16 9a4 4 0 0 1 0 6M19 6a8 8 0 0 1 0 12',
  image: 'M4 5h16v14H4zM8 10a1.5 1.5 0 1 0 0-3a1.5 1.5 0 1 0 0 3M20 15l-5-5-9 9',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  flame: 'M12 3c1 4 5 5 5 10a5 5 0 0 1-10 0c0-3 2-4 2-7 2 1 3 3 3 5',
  book: 'M4 5h7a2 2 0 0 1 2 2v13a2 2 0 0 0-2-2H4zM20 5h-7a2 2 0 0 0-2 2v13a2 2 0 0 1 2-2h7z',
  key: 'M15 7a4 4 0 1 0 0 8a4 4 0 1 0 0-8M11.5 13.5L4 21M7 18l2 2M5 20l1.5 1.5',
  lock: 'M5 11h14v10H5zM8 11V8a4 4 0 0 1 8 0v3',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  eye: 'M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6a3 3 0 1 0 0-6',
  copy: 'M9 9h11v11H9zM5 15H4V4h11v1',
  clock: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 7v5l3 2',
  link: 'M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1',
  file: 'M6 3h8l5 5v13H6zM14 3v5h5',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
  target: 'M12 3a9 9 0 1 0 0 18a9 9 0 1 0 0-18M12 8a4 4 0 1 0 0 8a4 4 0 1 0 0-8M12 11.5v1',
  refresh: 'M4 12a8 8 0 0 1 14-5.3L20 9M20 4v5h-5M20 12a8 8 0 0 1-14 5.3L4 15M4 20v-5h5',
  arrowRight: 'M5 12h14M13 6l6 6-6 6',
  arrowLeft: 'M19 12H5M11 6l-6 6 6 6',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3M5 11a7 7 0 0 0 14 0M12 18v3',
  user: 'M12 12a4 4 0 1 0 0-8a4 4 0 1 0 0 8M4 21v-1a7 7 0 0 1 16 0v1',
  filter: 'M4 5h16l-6 8v6l-4-2v-4z',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  layers: 'M12 3l9 5-9 5-9-5zM3 13l9 5 9-5',
  // Тренировка: режимы
  cards: 'M4 6h12v14H4zM8 3h12v14',
  testList: 'M4 5h16M4 12h16M4 19h10M18 17l2 2 3-4',
  meaning: 'M4 5h16M4 10h10M4 15h16M4 20h8',
  keyboard: 'M3 7h18v10H3zM7 11h.01M11 11h.01M15 11h.01M7 14h10',
  puzzle: 'M4 4h7v4a2 2 0 1 0 4 0V4h5v16H4z',
  match: 'M4 6h5M4 18h5M15 6h5M15 18h5M9 6l6 12M9 18l6-12',
  brain: 'M9 4a3 3 0 0 0-3 3 3 3 0 0 0-2 5 3 3 0 0 0 3 5 3 3 0 0 0 5 1V5a3 3 0 0 0-3-1M15 4a3 3 0 0 1 3 3 3 3 0 0 1 2 5 3 3 0 0 1-3 5 3 3 0 0 1-5 1',
  heart: 'M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z',
  blank: 'M4 12h4M10 12h4M16 12h4M10 16h4',
  swap: 'M4 12a8 8 0 0 1 14-5l2-2v6h-6l2-2a5 5 0 0 0-9 3M20 12a8 8 0 0 1-14 5l-2 2v-6h6l-2 2a5 5 0 0 0 9-3',
  trophy: 'M8 4h8v5a4 4 0 0 1-8 0zM8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4M12 13v4M8 21h8M10 17h4',
  article: 'M6 3h9l4 4v14H6zM14 3v5h5M9 12h7M9 16h7',
  subtitles: 'M3 5h18v14H3zM7 13h4M13 13h4M7 16h10',
  eyeOff: 'M3 3l18 18M10.6 5.1A10.8 10.8 0 0 1 12 5c6 0 10 7 10 7a17 17 0 0 1-3.2 3.9M6.6 6.6C3.9 8.3 2 12 2 12s4 7 10 7a9.8 9.8 0 0 0 5.4-1.6M9.9 9.9a3 3 0 0 0 4.2 4.2',
  calendar: 'M4 6h16v15H4zM4 10h16M8 3v4M16 3v4',
  camera: 'M4 8h3l2-3h6l2 3h3v11H4zM12 17a3.5 3.5 0 1 0 0-7a3.5 3.5 0 1 0 0 7',
  rotate: 'M20 12a8 8 0 1 1-2.3-5.6M20 4v5h-5',
  snowflake: 'M12 2v20M4.5 6.5l15 11M19.5 6.5l-15 11M9.5 3.5L12 6l2.5-2.5M9.5 20.5L12 18l2.5 2.5M3 10l3 .5-1 3M21 10l-3 .5 1 3M3 14l3-.5-1-3M21 14l-3-.5 1-3',
  gift: 'M3 9h18v4H3zM5 13v8h14v-8M12 9v12M12 9c-2-4-6-4-6-1.5S9 9 12 9zM12 9c2-4 6-4 6-1.5S15 9 12 9z',
  medal: 'M12 22a6 6 0 1 0 0-12a6 6 0 1 0 0 12M8.5 10.5L6 2h4l2 5 2-5h4l-2.5 8.5M12 13.5v4M10.5 15h3',
  bell: 'M6 16V11a6 6 0 0 1 12 0v5l2 2H4zM10 20a2 2 0 0 0 4 0',
  move: 'M12 3v18M3 12h18M12 3l-3 3M12 3l3 3M12 21l-3-3M12 21l3-3M3 12l3-3M3 12l3 3M21 12l-3-3M21 12l-3 3'
};

export const Icon = ({ name, size = 20, strokeWidth = 1.8, className = '', title }) => (
  <svg
    className={`ui-icon ${className}`}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden={title ? undefined : 'true'}
    role={title ? 'img' : undefined}
    aria-label={title}
  >
    <path d={ICONS[name] || ''} />
  </svg>
);

export default Icon;
